import Vue from 'vue';
import Unleash from '@js/plugins/unleash';

if (Unleash.hasFeature('ph_bir_reports')) {
    Vue.component(
        'receipt-postgres',
        require('./../receipt-ph/receipt.vue').default,
    );
} else if (Unleash.hasFeature('shell_sg_receipt')) {
    Vue.component(
        'receipt-postgres',
        require('./../receipt-shell-sg/receipt.vue').default,
    );
} else {
    Vue.component(
        'receipt-postgres',
        require('./../receipt-postgres/receipt.vue').default,
    );
}

Vue.component('transactionTypeSummary', () =>
    import(/* webpackChunkName: 'transaction' */ './sumTransactionType.vue'),
);

Vue.component('transactionChart', () =>
    import(/* webpackChunkName: 'transaction' */ './chart.vue'),
);

Vue.component('transaction-breakdown', () =>
    import(/* webpackChunkName: 'transaction' */ './transaction-breakdown.vue'),
);

Vue.component('transaction-breakdown-details', () =>
    import(/* webpackChunkName: 'transaction' */ './transaction-breakdown-details.vue'),
);

Vue.component('vuetable_transaction', () =>
    import(/* webpackChunkName: 'transaction' */ './vuetable_transaction.vue'),
);

Vue.component('vuepopup_receipt', () =>
    import(/* webpackChunkName: 'transaction' */ './side_receipt.vue'),
);
